import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { useGetDisplayOptionsClasses } from '~/composables/useGetDisplayOptionsClasses';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BlockExpandableTabInContainer',
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    image: {
      type: Object,
      default: function _default() {}
    },
    displayOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    index: {
      type: Number,
      required: true
    },
    currentActiveTab: {
      type: Number,
      required: true
    },
    currentClassName: {
      type: String,
      required: true
    }
  },
  emits: ['changeView'],
  setup: function setup(__props, _ref) {
    var _props$image, _props$image$fields, _props$image$fields$f;
    var emit = _ref.emit;
    var props = __props;
    var url = (_props$image = props.image) === null || _props$image === void 0 ? void 0 : (_props$image$fields = _props$image.fields) === null || _props$image$fields === void 0 ? void 0 : (_props$image$fields$f = _props$image$fields.file) === null || _props$image$fields$f === void 0 ? void 0 : _props$image$fields$f.url;
    var classes = useGetDisplayOptionsClasses(props.displayOptions);
    var styles = reactive({
      'background-image': "url(".concat(url, ")")
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      url: url,
      classes: classes,
      styles: styles,
      AzIcon: AzIcon
    };
  }
});